import styled from 'styled-components'

export const BannerOutroContainer = styled.section`
  padding: 6rem var(--paddingD);
  background: url(${props => props.bg}) no-repeat center center;
  background-size: cover;
  text-align: center;

  .title {
    color: var(--light);
    font-size: 32px;
    font-weight: 700;
    margin-bottom: 3.5rem;
  }

  div {
    &.filter {
      background: var(--navyblue);
      opacity: 0.8;
    }

    &.text-container {
      position: relative;
    }
  }

  a.mobile {
    display: none;
  }

  @media only screen and (max-width: 900px) {
    .title {
      font-size: 28px;
    }

    a {
      &.desktop {
        display: none;
      }

      &.mobile {
        display: block;
      }
    }
  }
`
